import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  ordinalNumber: {
    required,
  },
  documentCreationDate: {
    required,
  },
  documentExpirationDate: {
    required,
  },
  customer: {
    required,
  },
  commercialistId: {
    required,
  },
  interestAreaId: {
    required,
  },
};

export default validations;